// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Parameters {
        border: 1px solid #e4e4e4;
        border-bottom: none;

        background-color: #fff;

        padding: 20px;
        padding-top: 10px;

        box-sizing: border-box;
        width: 100%;

        display: flex;
        flex-direction: column;
        gap: 12.5px;
}

.Footer_title {
        font-size: 12px;
        font-family: "Montserrat";
        line-height: 12px;

        display: flex;
        align-items: center;
        width: calc(100% + 15px);

        gap: 5px;

        margin-left: -13px;
}

.Footer_title > img {
        height: 16px;
}

.Footer_title > hr {
        border: 1px solid #e4e4e4;
        display: flex;
        flex-grow: 1;
}

.Parameters_row {
        display: flex;
        flex-grow: 1;

        gap: 25px;
}

.Parameters_column {
        height: 30px;
        width: 30%;

        display: flex;
        align-items: center;

        gap: 10px;
}

.Parameters_column.RAG {
        padding-top: 0.5px;
        line-height: 12px;
}

.Parameters_column.right {
        flex-grow: 1;
        width: unset;
}

.Parameters_label {
        font-family: "Montserrat";
        font-size: 12px;
        font-weight: 500;
}

.Parameters_RAG_outer {
        background-color: #d4d4d4;
        width: 30px;
        height: 12px;
        border-radius: 6px;

        display: flex;
        align-items: center;

        cursor: pointer;
}

.Parameters_RAG_outer.true {
        background-color: #dfa7aa;
}

.Parameters_RAG_inner {
        border: 2px solid #bbbbbb;
        background: linear-gradient(#ffffff, #ebebeb);
        height: 12px;
        aspect-ratio: 1;
        border-radius: 50%;
}

.Parameters_RAG_inner.true {
        margin-left: auto;

        border-color: #A14B51;
        background: linear-gradient(#db7178, #ac5459);
}

.Parameters_temperature {
        display: flex;
        flex-direction: column;
        justify-content: center;

        height: 100%;
        flex-grow: 1;

        position: relative;
}

input[type=range] {
        margin: 0;
}
input[type="range" i]::-webkit-slider-container,
input[type="range" i]::-webkit-slider-runnable-track {
        -webkit-user-modify: read-write !important;
}

input[type="range" i]::-webkit-slider-container {
        background-image: linear-gradient(90deg, #dfa7aa calc(var(--m)*100%), #D4D4D4 calc(var(--m)*100%));
        border-radius: 4px;
}

.Parameters_temperature_thumb {
        border: 2px solid #A14B51;
        color: #fff;
        background: linear-gradient(#db7178, #ac5459);
        border-radius: 8px;
        position: absolute;
        z-index: 1;
        width: 30px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;

        font-family: "Montserrat";
        font-size: 12px;
        font-weight: 600;

        margin-left: calc(var(--m)*(100% - 34px));

        pointer-events: none;
}

.Footer_dropdown {
        width: 100%;
}

.Footer_context {
        border-radius: 6px;
        border: 1px solid #e4e4e4;
        height: 30px;
        width: 100%;
        box-sizing: border-box;

        padding: 0 10px;
        font-family: "Montserrat";
        font-weight: 500;
        font-size: 12px;
}

.Footer {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;

        height: 30px;
        width: 100%;

        display: flex;
        flex-shrink: 0;
}

.Footer_button {
        border: 1px solid #e4e4e4;
        border-right: none;

        background-color: #fff;

        padding: 0;

        box-sizing: border-box; /* Else label overflows */
        height: 100%;
        display: flex;
        flex-basis: 0;
        flex-grow: 1;

        align-items: center;
        justify-content: center;
        gap: 10px;

        font-family: "Montserrat";
        font-size: 12px;

        position: relative;

        cursor: pointer;
}

.Footer_button_icon {
        height: 16px;
}

.Footer_button_icon.true {
        height: 6px;
}

.Footer_button_label {
        font-family: "Montserrat";
        font-size: 12px;
        font-weight: 500;
}

.Footer_button.left {
        border-bottom-left-radius: 8px;

        max-width: 30px;
}

.Footer_button.left.true {
        border-top-color: transparent;
}

.Footer_button.right {
        border: none;
        border-bottom-right-radius: 8px;
}

.Footer_button.generate {
        background-color: #5c8f83;
}

.Footer_button.proceed {
        background-color: rgb(14, 187, 255);
}

.Footer_button.invert {
        color: #fff;
}

.Footer_button.invert > img {
        filter: brightness(0) invert(1);
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;QACQ,yBAAyB;QACzB,mBAAmB;;QAEnB,sBAAsB;;QAEtB,aAAa;QACb,iBAAiB;;QAEjB,sBAAsB;QACtB,WAAW;;QAEX,aAAa;QACb,sBAAsB;QACtB,WAAW;AACnB;;AAEA;QACQ,eAAe;QACf,yBAAyB;QACzB,iBAAiB;;QAEjB,aAAa;QACb,mBAAmB;QACnB,wBAAwB;;QAExB,QAAQ;;QAER,kBAAkB;AAC1B;;AAEA;QACQ,YAAY;AACpB;;AAEA;QACQ,yBAAyB;QACzB,aAAa;QACb,YAAY;AACpB;;AAEA;QACQ,aAAa;QACb,YAAY;;QAEZ,SAAS;AACjB;;AAEA;QACQ,YAAY;QACZ,UAAU;;QAEV,aAAa;QACb,mBAAmB;;QAEnB,SAAS;AACjB;;AAEA;QACQ,kBAAkB;QAClB,iBAAiB;AACzB;;AAEA;QACQ,YAAY;QACZ,YAAY;AACpB;;AAEA;QACQ,yBAAyB;QACzB,eAAe;QACf,gBAAgB;AACxB;;AAEA;QACQ,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,kBAAkB;;QAElB,aAAa;QACb,mBAAmB;;QAEnB,eAAe;AACvB;;AAEA;QACQ,yBAAyB;AACjC;;AAEA;QACQ,yBAAyB;QACzB,6CAA6C;QAC7C,YAAY;QACZ,eAAe;QACf,kBAAkB;AAC1B;;AAEA;QACQ,iBAAiB;;QAEjB,qBAAqB;QACrB,6CAA6C;AACrD;;AAEA;QACQ,aAAa;QACb,sBAAsB;QACtB,uBAAuB;;QAEvB,YAAY;QACZ,YAAY;;QAEZ,kBAAkB;AAC1B;;AAEA;QACQ,SAAS;AACjB;AACA;;QAEQ,0CAA0C;AAClD;;AAEA;QACQ,kGAAkG;QAClG,kBAAkB;AAC1B;;AAEA;QACQ,yBAAyB;QACzB,WAAW;QACX,6CAA6C;QAC7C,kBAAkB;QAClB,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;;QAEvB,yBAAyB;QACzB,eAAe;QACf,gBAAgB;;QAEhB,yCAAyC;;QAEzC,oBAAoB;AAC5B;;AAEA;QACQ,WAAW;AACnB;;AAEA;QACQ,kBAAkB;QAClB,yBAAyB;QACzB,YAAY;QACZ,WAAW;QACX,sBAAsB;;QAEtB,eAAe;QACf,yBAAyB;QACzB,gBAAgB;QAChB,eAAe;AACvB;;AAEA;QACQ,8BAA8B;QAC9B,+BAA+B;;QAE/B,YAAY;QACZ,WAAW;;QAEX,aAAa;QACb,cAAc;AACtB;;AAEA;QACQ,yBAAyB;QACzB,kBAAkB;;QAElB,sBAAsB;;QAEtB,UAAU;;QAEV,sBAAsB,EAAE,yBAAyB;QACjD,YAAY;QACZ,aAAa;QACb,aAAa;QACb,YAAY;;QAEZ,mBAAmB;QACnB,uBAAuB;QACvB,SAAS;;QAET,yBAAyB;QACzB,eAAe;;QAEf,kBAAkB;;QAElB,eAAe;AACvB;;AAEA;QACQ,YAAY;AACpB;;AAEA;QACQ,WAAW;AACnB;;AAEA;QACQ,yBAAyB;QACzB,eAAe;QACf,gBAAgB;AACxB;;AAEA;QACQ,8BAA8B;;QAE9B,eAAe;AACvB;;AAEA;QACQ,6BAA6B;AACrC;;AAEA;QACQ,YAAY;QACZ,+BAA+B;AACvC;;AAEA;QACQ,yBAAyB;AACjC;;AAEA;QACQ,mCAAmC;AAC3C;;AAEA;QACQ,WAAW;AACnB;;AAEA;QACQ,+BAA+B;AACvC","sourcesContent":[".Parameters {\n        border: 1px solid #e4e4e4;\n        border-bottom: none;\n\n        background-color: #fff;\n\n        padding: 20px;\n        padding-top: 10px;\n\n        box-sizing: border-box;\n        width: 100%;\n\n        display: flex;\n        flex-direction: column;\n        gap: 12.5px;\n}\n\n.Footer_title {\n        font-size: 12px;\n        font-family: \"Montserrat\";\n        line-height: 12px;\n\n        display: flex;\n        align-items: center;\n        width: calc(100% + 15px);\n\n        gap: 5px;\n\n        margin-left: -13px;\n}\n\n.Footer_title > img {\n        height: 16px;\n}\n\n.Footer_title > hr {\n        border: 1px solid #e4e4e4;\n        display: flex;\n        flex-grow: 1;\n}\n\n.Parameters_row {\n        display: flex;\n        flex-grow: 1;\n\n        gap: 25px;\n}\n\n.Parameters_column {\n        height: 30px;\n        width: 30%;\n\n        display: flex;\n        align-items: center;\n\n        gap: 10px;\n}\n\n.Parameters_column.RAG {\n        padding-top: 0.5px;\n        line-height: 12px;\n}\n\n.Parameters_column.right {\n        flex-grow: 1;\n        width: unset;\n}\n\n.Parameters_label {\n        font-family: \"Montserrat\";\n        font-size: 12px;\n        font-weight: 500;\n}\n\n.Parameters_RAG_outer {\n        background-color: #d4d4d4;\n        width: 30px;\n        height: 12px;\n        border-radius: 6px;\n\n        display: flex;\n        align-items: center;\n\n        cursor: pointer;\n}\n\n.Parameters_RAG_outer.true {\n        background-color: #dfa7aa;\n}\n\n.Parameters_RAG_inner {\n        border: 2px solid #bbbbbb;\n        background: linear-gradient(#ffffff, #ebebeb);\n        height: 12px;\n        aspect-ratio: 1;\n        border-radius: 50%;\n}\n\n.Parameters_RAG_inner.true {\n        margin-left: auto;\n\n        border-color: #A14B51;\n        background: linear-gradient(#db7178, #ac5459);\n}\n\n.Parameters_temperature {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n\n        height: 100%;\n        flex-grow: 1;\n\n        position: relative;\n}\n\ninput[type=range] {\n        margin: 0;\n}\ninput[type=\"range\" i]::-webkit-slider-container,\ninput[type=\"range\" i]::-webkit-slider-runnable-track {\n        -webkit-user-modify: read-write !important;\n}\n\ninput[type=\"range\" i]::-webkit-slider-container {\n        background-image: linear-gradient(90deg, #dfa7aa calc(var(--m)*100%), #D4D4D4 calc(var(--m)*100%));\n        border-radius: 4px;\n}\n\n.Parameters_temperature_thumb {\n        border: 2px solid #A14B51;\n        color: #fff;\n        background: linear-gradient(#db7178, #ac5459);\n        border-radius: 8px;\n        position: absolute;\n        z-index: 1;\n        width: 30px;\n        height: 16px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        font-family: \"Montserrat\";\n        font-size: 12px;\n        font-weight: 600;\n\n        margin-left: calc(var(--m)*(100% - 34px));\n\n        pointer-events: none;\n}\n\n.Footer_dropdown {\n        width: 100%;\n}\n\n.Footer_context {\n        border-radius: 6px;\n        border: 1px solid #e4e4e4;\n        height: 30px;\n        width: 100%;\n        box-sizing: border-box;\n\n        padding: 0 10px;\n        font-family: \"Montserrat\";\n        font-weight: 500;\n        font-size: 12px;\n}\n\n.Footer {\n        border-bottom-left-radius: 8px;\n        border-bottom-right-radius: 8px;\n\n        height: 30px;\n        width: 100%;\n\n        display: flex;\n        flex-shrink: 0;\n}\n\n.Footer_button {\n        border: 1px solid #e4e4e4;\n        border-right: none;\n\n        background-color: #fff;\n\n        padding: 0;\n\n        box-sizing: border-box; /* Else label overflows */\n        height: 100%;\n        display: flex;\n        flex-basis: 0;\n        flex-grow: 1;\n\n        align-items: center;\n        justify-content: center;\n        gap: 10px;\n\n        font-family: \"Montserrat\";\n        font-size: 12px;\n\n        position: relative;\n\n        cursor: pointer;\n}\n\n.Footer_button_icon {\n        height: 16px;\n}\n\n.Footer_button_icon.true {\n        height: 6px;\n}\n\n.Footer_button_label {\n        font-family: \"Montserrat\";\n        font-size: 12px;\n        font-weight: 500;\n}\n\n.Footer_button.left {\n        border-bottom-left-radius: 8px;\n\n        max-width: 30px;\n}\n\n.Footer_button.left.true {\n        border-top-color: transparent;\n}\n\n.Footer_button.right {\n        border: none;\n        border-bottom-right-radius: 8px;\n}\n\n.Footer_button.generate {\n        background-color: #5c8f83;\n}\n\n.Footer_button.proceed {\n        background-color: rgb(14, 187, 255);\n}\n\n.Footer_button.invert {\n        color: #fff;\n}\n\n.Footer_button.invert > img {\n        filter: brightness(0) invert(1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
